module.exports = __webpack_public_path__ + "media/country_flags/vc-1cfda00d.png";